<template>
  <div id="end" class="dt-footer">
    <div class="d-flex align-items-center">
      <div class="ft-logo">
        <img
          :src="staticImgBaseUrl + '/images/global/logoLgTemplate.svg'"
          class="ft-logo-img"
        />
      </div>
      <div class="tag-line fs-20 color-white">
        <div>#Famous Lousiana Chicken</div>
        <div class="fs-12 lh16">Made with ❤️ in India</div>
      </div>
    </div>
    <div class="ft-menu d-flex">
      <div v-for="value in footerData" :key="value">
        <span
          @click="handleClick(value)"
          class="color-white fs-14 pr32 nowrap"
          >{{ value }}</span
        >
      </div>
    </div>

    <div class="d-flex align-items-center">
      <!-- <div class="color-white fs-14 pl32">Feedback</div> -->
      <div class="ft-social">
        <ul class="d-flex align-items-center">
          <li>
            <a href="https://www.instagram.com/popeyes_india">
              <img
                :src="staticImgBaseUrl + '/images/global/hk-insta.svg'"
                class="insta-logo-img"
              />
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/popeyesindia">
              <img
                :src="staticImgBaseUrl + '/images/global/hk-fb.svg'"
                class="fb-logo-img"
              />
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.jubl.popeyes"
            >
              <img
                :src="staticImgBaseUrl + '/images/global/hk-gplay.svg'"
                class="gplay-logo-img"
              />
            </a>
          </li>
          <li>
            <a
              href="https://apps.apple.com/in/app/popeyes-india-food-delivery/id1603809688"
            >
              <img
                :src="staticImgBaseUrl + '/images/global/hk-apstore.svg'"
                class="apstore-logo-img"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { staticImgBaseUrl, site } from "../config/apiEndpoints";
import DesktopFooterData from "../assets/FallbackData/DesktopFooterData.json";
import utility from "../helpers/utility";

export default {
  name: "DesktopFooter",
  components: {
    //
  },
  data() {
    return {
      staticImgBaseUrl,
      DesktopFooterData,
    };
  },
  mounted() {
    //
  },
  methods: {
    //
    handleClick(item) {
      switch (item) {
        case "Home": {
          if (!utility.isCurrentlyAtUrl("/store/")) {
            utility.redirectToHomeOrRedirectUrl();
          }
          break;
        }
        case "Menu": {
          utility.sendToMenuScreen();
          break;
        }
        case "About Us": {
          utility.redirectToLinkRewrite("/content/about-us");
          break;
        }
        case "Nutritional Info": {
          utility.redirectToLinkRewrite("/content/nutritional-info");
          break;
        }
        case "View Offers": {
          utility.sendToOffersScreen();
          break;
        }
        case "My Orders": {
          utility.sendToOrderHistory();
          break;
        }
        case "My Favourites": {
          utility.redirectToLinkRewrite("/my-favourites");
          break;
        }
        case "My Addresses": {
          utility.sendToMyAddressPage();
          break;
        }
        case "My Profile": {
          utility.redirectToLinkRewrite("/my-profile");
          break;
        }
        case "My Wallet": {
          utility.redirectToLinkRewrite("/wallet");
          break;
        }
        case "Contact": {
          utility.redirectToLinkRewrite("/content/contact-us");
          break;
        }
        case "Privacy Policy": {
          utility.redirectToLinkRewrite("/content/privacy-policy");
          break;
        }
        case "Blog": {
          utility.redirectToLinkRewrite("/blog/blogs-home");
          break;
        }
        case "Terms & Conditions": {
          utility.redirectToLinkRewrite("/content/tnc");
          break;
        }
      }
    },
  },
  computed: {
    footerData() {
      return DesktopFooterData?.[site] || DesktopFooterData?.["common"];
    },
  },
};
</script>
